"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashoutRefinance = CashoutRefinance;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyleWrapper = _styledComponents.default.div`

ul{

    background-color: #054894;
    box-shadow: 1px 1px 8px #c7c7c7;
    border-radius: 10px;
    padding: 20px 20px;
    color: #fff;

}

p{
    // color:grey;
    margin-bottom:0.5rem;
}

h2{
    // color: #164686;
    margin-bottom:20px;
}

h4{
    // color: #164686;
}



`;
const TableWrapper = _styledComponents.default.div`

.table{
    border: 1px solid #ececec;
}
.table tr td:first-child {
    background: #25a7df;
    color: #fff;
  }

  td{
      vertical-align: middle;
    //   color:grey;
  }

@media(max-width:768px){
    .table-bordered thead td, .table-bordered thead th {
      min-width: auto !important;
      vertical-align: top !important;
      }
      .table-bordered > thead > tr > th:first-child{
        width: auto !important;
      }
      .table-responsive{
          overflow-x: auto;
      }
  }
`;
function CashoutRefinance() {
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Cash-Out Refinance"))), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(StyleWrapper, null, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: _indexModule.default.headerRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.header_border
  }, " "), /*#__PURE__*/_react.default.createElement("h2", null, "Cash-Out Refinance: Key Considerations"), /*#__PURE__*/_react.default.createElement("p", null, "A cash-out refinance provides you a means of using the equity you have built up in your home to get cash at closing. If you decide to obtain a cash-out refinance loan, you will sign binding legal documents that will have important legal and financial implications for you and your estate. It is therefore important to understand the terms of cash out refinance."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "Please take a moment to review the key considerations listed below that come with cash out refinance, discuss these with your family, and reflect on your personal needs."), /*#__PURE__*/_react.default.createElement(TableWrapper, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    responsive: true
  }, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    style: {
      width: '180px'
    }
  }, "Loss of Equity"), /*#__PURE__*/_react.default.createElement("td", null, "When you commit to a cash-out refinance, you forfeit some or all of the equity in your home.")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Extension of Mortgage Term"), /*#__PURE__*/_react.default.createElement("td", null, "Cash-out refinance will reset your current mortgage, extending the term over which you must make payments on a mortgage, unless you refinance for a lower number of years.")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Higher Interest over the Mortgage Term"), /*#__PURE__*/_react.default.createElement("td", null, "With a cash-out refinance, you are taking on more debt which can result in higher interest rate and/or interest amount being paid over the life of the loan as compared to the total interest you will pay on any debts that you intend to consolidate with this refinance.")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Negative Equity"), /*#__PURE__*/_react.default.createElement("td", null, "Losing your equity puts your home at a greater risk of being underwater (i.e. owing more than home is worth) if the property values in your area drop. You will still be obligated to pay this loan. You could lose your home, along with other substantial adverse reputational, legal and financial implications, if you do not meet your mortgage loan obligations.")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Closing Costs"), /*#__PURE__*/_react.default.createElement("td", null, "A refinance requires paying additional closing costs. Realizing real savings through a refinance requires staying in your home long enough to break even on the cost of refinance. If you plan to move within a few years, refinance may not yield any savings or may even cost you money."))))), /*#__PURE__*/_react.default.createElement("p", null, "You may also want to consult with a Housing Counselor at ", /*#__PURE__*/_react.default.createElement("a", {
    href: "http://www.consumerfinance.gov/find-a-housing-counselor",
    target: "_blank",
    title: "Click here to find a housing counselor"
  }, "http://www.consumerfinance.gov/find-a-housing-counselor"), " to determine whether this is a right decision for you."), /*#__PURE__*/_react.default.createElement("p", null, "To learn more about cash out refinancing with Sun West Mortgage Company, Inc., give us a call at ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:18447869378"
  }, "1-844-SUN-WEST"), " to speak to a friendly and knowledgeable mortgage professional.")))));
}
var _default = exports.default = CashoutRefinance;